import { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../images/logo.jpeg";
import logoname from "../images/logoname.jpeg";
import navbarbg from "../images/navbarbg.jpeg";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <div
        className="navbar-bg"
        style={{ backgroundImage: `url(${navbarbg})` }}
      ></div>
      <nav className="navbar">
        {/* LOGO */}
        <div className="logo-container">
          <img src={logo} className="logo-img" alt="logo" />
          <h1 className="logoname">
            UNIQUE GLOBAL <br /> EXPORTS
          </h1>
        </div>

        {/* DESKTOP MENU */}
        <ul className="nav-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About Us</Link>
          </li>
          <li>
            <Link to="/products">Products</Link>
          </li>
          <li>
            <Link to="/process">Our Process</Link>
          </li>
          <li>
            <Link to="/contact">Contact Us</Link>
          </li>
          <li className="btn green">
            <Link to="/contact">Get a Quote</Link>
          </li>
        </ul>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setMenuOpen(true)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="menu-header">
              <img src={logoname} alt="Company Logo" className="menu-logo" />
              <button className="close-btn" onClick={() => setMenuOpen(false)}>
                ✕
              </button>
            </div>

            <ul>
              <li>
                <Link to="/" onClick={() => setMenuOpen(false)}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setMenuOpen(false)}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" onClick={() => setMenuOpen(false)}>
                  Products
                </Link>
              </li>
              <li>
                <Link to="/process" onClick={() => setMenuOpen(false)}>
                  Our Process
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => setMenuOpen(false)}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}

      {/* STYLES */}
      <style>{`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        .navbar {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 80px;

          display: flex;
          justify-content: space-between;
          align-items: center;

          padding: 0 20px;
          z-index: 1000;

          background: #656567;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);

          border-bottom: 1px solid rgba(255,255,255,0.15);
        }
          .navbar {
            z-index: 1000;
          }

          .navbar-bg {
            z-index: 0;
          }
          .navbar {
            background: rgba(0, 0, 0, 0.4);
          }
          .navbar-bg {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 80px;

            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;

            z-index: 0;
          }

        /* LOGO */
        .logo-container {
          display: flex;
          align-items: center;
          gap: 8px;
          max-width: 60%;
        }

        .logo-img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
        }

        .logoname {
          font-size: 18px;
          font-weight: 800;
          letter-spacing: 1px;
          color: white;

          white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;

          // border-bottom: 2px solid #22c55e;

          text-shadow: 0 2px 4px rgba(0,0,0,0.6);
        }

        /* NAV LINKS */
        .nav-links {
          display: flex;
          gap: 20px;
          list-style: none;
          align-items: center;
        }

        .nav-links li {
          position: relative;
          cursor: pointer;
          font-weight: 600;
          color: white;
          transition: 0.3s;
        }

        .nav-links li a {
          text-decoration: none;
          color: inherit;
        }

        .nav-links li:hover {
          color: #22c55e;
        }

        .nav-links li::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -5px;
          width: 0%;
          height: 2px;
          background: #22c55e;
          transition: 0.3s;
        }

        .nav-links li:hover::after {
          width: 100%;
        }

        /* BUTTON */
        .btn.green {
          background: #22c55e;
          padding: 8px 14px;
          border-radius: 20px;
          color: white;
          transition: 0.3s ease;
        }

        .btn.green:hover {
          color: black;
        }

        /* HAMBURGER */
        .hamburger {
          display: none;
          flex-direction: column;
          gap: 5px;
          cursor: pointer;
        }

        .hamburger span {
          width: 25px;
          height: 3px;
          background: white;
        }

        /* MOBILE MENU */
        .menu-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100vh;
          background: rgba(0,0,0,0.6);
          z-index: 2000;
        }

        .mobile-menu {
          width: 75%;
          max-width: 300px;
          height: 100%;
          background:white;
          padding: 20px;
          animation: slideIn 0.3s ease forwards;
        }

        @keyframes slideIn {
          from { transform: translateX(-100%); }
          to { transform: translateX(0); }
        }

        .menu-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .menu-logo {
          width: 100%;
        }

        .close-btn {
          font-size: 20px;
          background: none;
          border: none;
          color: white;
          cursor: pointer;
        }

        .mobile-menu ul {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .mobile-menu li a {
          color: black;
          text-decoration: none;
          font-size: 18px;
        }

        /* RESPONSIVE */
        @media(max-width: 768px) {
          .nav-links {
            display: none;
          }
            .menu-logo {
          width: 200px;
        }

          .hamburger {
            display: flex;
          }
          .logo-img {
            width: 70px;
            height: 70px;
          }

          .logoname {
            font-size: 18px;
            font-weight: 800;
          }
        }
      `}</style>
    </>
  );
}
